import React from 'react';
import './Recommendations.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSignInAlt, faHeart, faShoppingBag } from '@fortawesome/free-solid-svg-icons';
import Header from "./common/Header";
import FeaturedSection from "./common/FeaturedSection";

// Add the Font Awesome icons to the library
library.add(faSignInAlt, faHeart, faShoppingBag);

function StylistList() {
    return (
        <div>
            <Header/>
            <main className="recommendations-main">
                <FeaturedSection
                    title="Summer Girl"
                    description={[
                        'Рубашка и футболка из shop-to-shop, юбка из emini-brand',
                        'Подобрано стилистом @kate21',
                    ]}
                    buttonText="Shop the look"
                    imageUrl="https://static.insales-cdn.com/images/products/1/2537/856435177/IMG_4136_result.jpg"
                    linkTo="/look/1"
                />
                <FeaturedSection
                    title="Too smart casual"
                    description={[
                        'Кроссовки - shop to shop - 10 000р',
                        'Рубашка - my top line - 7 000р',
                        'Футболка - my top line 5 000р',
                    ]}
                    buttonText="Детали"
                    imageUrl="https://take-two.ru/wp-content/uploads/IMG_1448-scaled.jpg"
                    linkTo="/look/2"
                    reverse
                />
                <FeaturedSection
                    title="Summer Girl"
                    description={[
                        'Кроссовки - shop to shop - 10 000р',
                        'Рубашка - my top line - 7 000р',
                        'Футболка - my top line 5 000р',
                    ]}
                    buttonText="Shop the look"
                    imageUrl="https://take-two.ru/wp-content/uploads/74130539.jpg"
                    linkTo="/look/3"
                />
                <FeaturedSection
                    title="Too smart casual"
                    description={[
                        'Кроссовки - shop to shop - 10 000р',
                        'Рубашка - my top line - 7 000р',
                        'Футболка - my top line 5 000р',
                    ]}
                    buttonText="Детали"
                    imageUrl="https://take-two.ru/wp-content/uploads/72278641.jpg"
                    linkTo="/look/1"
                    reverse
                />
                <FeaturedSection
                    title="Summer Girl"
                    description={[
                        'Кроссовки - shop to shop - 10 000р',
                        'Рубашка - my top line - 7 000р',
                        'Футболка - my top line 5 000р',
                    ]}
                    buttonText="Детали"
                    imageUrl="https://static.insales-cdn.com/images/products/1/3365/813075749/29.01_%D0%A8%D1%82%D0%A86025_result.jpg"
                    linkTo="/look/1"
                />
                <FeaturedSection
                    title="Too smart casual"
                    description={[
                        'Кроссовки - shop to shop - 10 000р',
                        'Рубашка - my top line - 7 000р',
                        'Футболка - my top line 5 000р',
                    ]}
                    buttonText="Детали"
                    imageUrl="https://take-two.ru/wp-content/uploads/72278641.jpg"
                    linkTo="/look/1"
                    reverse
                />
            </main>
        </div>
    );
}

export default StylistList;
